export const PYTHON_INDENT = '    ';
